import React from "react";
import { Route, Navigate } from "react-router-dom";
import MarketingList from "../feature-module/Marketing/marketinglist";

const routes = all_routes;

import Profile from "../feature-module/pages/profile";
import Signin from "../feature-module/pages/login/signin";
import { all_routes } from "./all_routes";
import EditMarketing from "../feature-module/Marketing/EditMarketing";
import Settings from "../feature-module/Settings/SettingsTab";
import SettingsRoutes from "../feature-module/Settings/SettingsRoutes";
import AccessControl from "../feature-module/Settings/accessControl";
import AccessControlRoutes from "../feature-module/Settings/AccessControlRoutes";
import LetterProcessingRoutes from "../feature-module/letter-processing/LetterProcessingRoutes";
import EditCallCenter from "../feature-module/Settings/editcallcenters";
import MediaPlanList from "../feature-module/media-plan/mediaplanlist";
import EditMediaPlan from "../feature-module/media-plan/editmediaplan";
import PhoneNumbers from "../feature-module/Marketing/phoneNumbers";
import OrdersList from "../feature-module/inventory/orderslist";
import Suppliers from "../feature-module/inventory/suppliers";
import Warehouses from "../feature-module/inventory/warehouses";
import PrintList from "../feature-module/inventory/printlist";
import Error404 from "../feature-module/pages/errorpages/error404";
import Error500 from "../feature-module/pages/errorpages/error500";
import SalesDashboard from "../feature-module/Reports/SalesDashboard";
import ProtectedRoute from "./protected_route";
import AdminRoute from "./admin_route";
import MailingReport from "../feature-module/Reports/mailingreport";
import MailingResponseTabs from "../feature-module/Reports/MailingResponseTabs";
import Lists from "../feature-module/media-plan/lists";
import SalesByDate from "../feature-module/Reports/sales-by-date";
import StockData from "../feature-module/DataModule/stockdata";
import MailingResponseLTV from "../feature-module/DataModule/mailingResponseLTVData";
import SalesDump from "../feature-module/DataModule/salesDumpData";
import SalesDumpAnalysis from "../feature-module/AIAnalysis/salesDumpAnalysis";
import Data from "../feature-module/DataModule/data";
import ListReport from "../feature-module/Reports/lists-report";
import ProductDashboard from "../feature-module/inventory/productDashboard";
import MailFile from "../feature-module/Database/MailFile";
import Customer from "../feature-module/Database/Customer";
import InternalCustomerDetail from "../feature-module/Database/Customer/InternalCustomerDetail";
import Validator from "../feature-module/Validator/main";
import SalesDashboardTab from "../feature-module/Reports/SalesDashboardTab";
import NewVendorReport from "../feature-module/Reports/NewVendorReport";
import DynamicProfitAndLoss from "../feature-module/Accounting/components/Reports/ProfitAndLoss";
import DynamicBalanceSheet from "../feature-module/Accounting/components/Reports/BalanceSheet";
import VendorAgingReportPage from "../feature-module/Accounting/components/Reports/VendorAgingReport";
import CostsPage from "../feature-module/costs/CostsPage";
import AccountingRoutes from "../feature-module/Accounting/AccountingRoutes";
import ActionsPage from "../feature-module/Actions/ActionsPage";
import ViewMediaPlan from "../feature-module/media-plan/components/viewMediaPlan";
import CashFlowEstimationRoutes from "../feature-module/CashFlowEstimation/CashFlowEstimationRoutes";
import NoPermissionsPage from "../feature-module/pages/NoPermissionsPage";
import PdfParserRoutes from "../feature-module/pdf-parser/PdfParserRoutes";

export const publicRoutes = [
  {
    id: 2,
    path: routes.productlist,
    name: "products",
    element: (
      <ProtectedRoute>
        <ProductDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 2109,
    path: routes.productViewTab,
    name: "product-view",
    element: (
      <ProtectedRoute>
        <ProductDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 106,
    path: routes.profile,
    name: "profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 120,
    path: routes.marketinglist,
    name: "marketing",
    element: (
      <ProtectedRoute>
        <MarketingList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 121,
    path: routes.editmarketing,
    name: "edit-marketing",
    element: (
      <ProtectedRoute>
        <EditMarketing />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 122,
    path: `${routes.settings}/*`,
    name: "settings",
    element: (
      <ProtectedRoute>
        <SettingsRoutes />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 123,
    path: `${routes.letterProcessing}/*`,
    name: "letter-processing",
    element: (
      <ProtectedRoute>
        <LetterProcessingRoutes />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1222,
    path: routes.actions,
    name: "actions",
    element: (
      <ProtectedRoute>
        <ActionsPage />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1237,
    path: `${routes.accessControl}/*`,
    name: "access-control",
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <AccessControlRoutes />
        </AdminRoute>
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 124,
    path: routes.phoneNumbers,
    name: "phone-numbers",
    element: (
      <ProtectedRoute>
        <PhoneNumbers />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 125,
    path: routes.editcallcenter,
    name: "edit-call-center",
    element: (
      <ProtectedRoute>
        <EditCallCenter />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 127,
    path: routes.mediaPlansList,
    name: "media-plans",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 128,
    path: routes.mediaPlansCampaign,
    name: "media-plans-campaign",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 129,
    path: routes.mediaPlanPlanning,
    name: "media-plans-planning",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 130,
    path: routes.mediaPlanPurchaseOrderEvolution,
    name: "media-plans-purchase-order-evolution",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 131,
    path: routes.mediaPlanRor100Days,
    name: "media-plans-ror-100-days",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 132,
    path: routes.mediaPlanLists,
    name: "media-plans-lists",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1321,
    path: routes.mediaPlanCosts,
    name: "media-plans-costs",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 133,
    path: routes.editMediaPlan,
    name: "edit-media-plan",
    element: (
      <ProtectedRoute>
        <EditMediaPlan />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 180,
    path: routes.mediaPlansViewByCode,
    name: "mediaPlansViewByCode",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 134,
    path: routes.orderlist,
    name: "order-list",
    element: (
      <ProtectedRoute>
        <OrdersList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 135,
    path: routes.supliersList,
    name: "suppliers",
    element: (
      <ProtectedRoute>
        <Suppliers />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 136,
    path: routes.warehousesList,
    name: "warehouses",
    element: (
      <ProtectedRoute>
        <Warehouses />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 137,
    path: routes.printList,
    name: "print-list",
    element: (
      <ProtectedRoute>
        <PrintList />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 138,
    path: routes.mailingReport,
    name: "mailing-report",
    element: (
      <ProtectedRoute>
        <MailingResponseTabs />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 139,
    path: routes.lists,
    name: "lists",
    element: (
      <ProtectedRoute>
        <Lists />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 141,
    path: routes.salesByDate,
    name: "sales-by-date",
    element: (
      <ProtectedRoute>
        <SalesDashboardTab />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1422,
    path: routes.customerReports,
    name: "customer-reports",
    element: (
      <ProtectedRoute>
        <SalesDashboardTab />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 142,
    path: routes.stockData,
    name: "stock-data",
    element: (
      <ProtectedRoute>
        <StockData />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 143,
    path: routes.mailingResponseLTVData,
    name: "mailing-response-ltv-data",
    element: (
      <ProtectedRoute>
        <MailingResponseTabs />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 144,
    path: routes.salesDumpData,
    name: "sales-dump-data",
    element: (
      <ProtectedRoute>
        <SalesDashboardTab />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 145,
    path: routes.salesDumpAnalysis,
    name: "sales-dump-analysis",
    element: (
      <ProtectedRoute>
        <SalesDashboardTab />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },

  {
    id: 146,
    path: routes.listReport,
    name: "list report",
    element: (
      <ProtectedRoute>
        <MailingResponseTabs />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 1466,
    path: routes.listSelection,
    name: "list selection",
    element: (
      <ProtectedRoute>
        <MailingResponseTabs />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 1467,
    path: routes.campaignListSelection,
    name: "campaign list selection",
    element: (
      <ProtectedRoute>
        <MailingResponseTabs />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },

  {
    id: 1411,
    path: routes.salesDashboard,
    name: "Sales Dashboard",
    element: (
      <ProtectedRoute>
        <SalesDashboardTab />{" "}
      </ProtectedRoute>
    ),

    route: Route,
  },
  {
    id: 1412,
    path: routes.vendorReport,
    name: "Vendor Report",
    element: (
      <ProtectedRoute>
        <NewVendorReport />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1413,
    path: routes.profitLossReport,
    name: "Profit & Loss Report",
    element: (
      <ProtectedRoute>
        <DynamicProfitAndLoss />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1414,
    path: routes.balanceSheetReport,
    name: "Balance Sheet Report",
    element: (
      <ProtectedRoute>
        <DynamicBalanceSheet />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1415,
    path: routes.vendorAgingReport,
    name: "Vendor Aging Report",
    element: (
      <ProtectedRoute>
        <VendorAgingReportPage />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 147,
    path: routes.mailFiles,
    name: "mail files",
    element: (
      <ProtectedRoute>
        <MailFile />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 148,
    // path: routes.mfVs4,
    path: routes.mfVsPersons,
    name: "mf vs persons",
    element: (
      <ProtectedRoute>
        <MailFile />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1488,
    // path: routes.mfVs4,
    path: routes.mfVsTimelineYears,
    name: "mf vs timeline years",
    element: (
      <ProtectedRoute>
        <MailFile />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 149,
    path: routes.mfVsList,
    name: "mf vs list",
    element: (
      <ProtectedRoute>
        <MailFile />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1479,
    path: routes.validatorMarketingFile,
    name: "validator-marketing-file",
    element: (
      <ProtectedRoute>
        <Validator />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 151,
    path: routes.customer,
    name: "customer",
    element: (
      <ProtectedRoute>
        <Customer />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 152,
    path: routes.customerDetail,
    name: "Customer Detail",
    element: (
      <ProtectedRoute>
        <Customer />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 153,
    path: routes.customer,
    name: "Total Customer",
    element: (
      <ProtectedRoute>
        <Customer />{" "}
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 154,
    path: routes.internalCustomerDetail,
    name: "internal-customer-detail",
    element: (
      <ProtectedRoute>
        <InternalCustomerDetail />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 155,
    path: routes.mfVsTimelineMonths,
    name: "mf vs timeline months",
    element: (
      <ProtectedRoute>
        <SalesDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 160,
    path: `${routes.accounting}/*`, // This is critical
    name: "accounting",
    element: (
      <ProtectedRoute>
        <AccountingRoutes />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 156,
    path: routes.costs,
    name: "costs",
    element: (
      <ProtectedRoute>
        <CostsPage />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1561,
    path: routes.estimatedCashFlow,
    name: "estimated-cash-flow",
    element: (
      <ProtectedRoute>
        <CashFlowEstimationRoutes />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 157,
    path: routes.data,
    name: "data",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1570,
    path: routes.dataSalesReport,
    name: "data-sales-report",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1569,
    path: routes.dataSublyticsOrders,
    name: "data-sublytics-orders",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1571,
    path: routes.dataWordpressOrders,
    name: "data-wordpress-orders",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1576,
    path: routes.dataTigerTechOrders,
    name: "data-tigertech-orders",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1577,
    path: routes.dataSocrateOrders,
    name: "data-socrate-orders",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 1572,
    path: routes.dataAuthorizeTransactions,
    name: "data-authorize-transactions",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1573,
    path: routes.dataStripeTransactions,
    name: "data-stripe-transactions",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1574,
    path: routes.dataTransactionDetails,
    name: "data-transaction-details",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1575,
    path: routes.dataStripeTransactionDetails,
    name: "data-stripe-transaction-details",
    element: (
      <ProtectedRoute>
        <Data />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1576,
    path: routes.mediaplans,
    name: "media-plans-costs",
    element: (
      <ProtectedRoute>
        <MediaPlanList />
      </ProtectedRoute>
    ),
    route: Route,
  },
  {
    id: 1600,
    path: `${routes.pdfParser}/*`,
    name: "pdf-parser",
    element: (
      <ProtectedRoute>
        <PdfParserRoutes />
      </ProtectedRoute>
    ),
    route: Route,
  },
];

export const posRoutes = [];
export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },

  {
    id: 18,
    path: routes.error404,
    name: "error404",
    element: <Error404 />,
    route: Route,
  },
  {
    id: 19,
    path: routes.error500,
    name: "error500",
    element: <Error500 />,
    route: Route,
  },
  {
    id: 117,
    path: routes.noPermissions,
    name: "No Permissions",
    element: <NoPermissionsPage />,
  },
  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/error-404" />,
    route: Route,
  },
];
